export const environment = {
	production: true,
	staging: false,
	googleSireloApiKey: 'AIzaSyAYk0el8d_MmO2O-XJVKqMWjM7VwJ6zfHE',
	googleAffiliateApiKey: 'AIzaSyA9gZjUL46NbKzOoJcB8zGUuhdbgnDGrkc',
	erpApiBaseUrl: 'https://erp2.triglobal.info/api',
	bugsnagId: '033c6154c9ee21fa2d68b64cb624d0a8',
	mixpanelToken: '24134cbf69423093953c0832deef3fbb',
	clarityToken: 'vxpcdu5r86'
};
